import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Vote = ({ surveyData, videoBoxData, voteTitleImage }) => {
    const rankNumList = [
        'https://x0.ifengimg.com/ucms/2023_37/17F763234F8ACA69CA3300503A53C224C02C5779_size5_w48_h42.png',
        'https://x0.ifengimg.com/ucms/2023_37/5DCA5F501C517BEAD722F71BCF05A3DAEE077340_size5_w48_h42.png',
        'https://x0.ifengimg.com/ucms/2023_37/2B7AAE7C0B9B1D32358166DD879A59D28BF36BF2_size5_w48_h42.png',
    ];
    const voteList = surveyData?.result?.[0]?.resultArray?.option || [];
    const rankVote = [];

    voteList.forEach((outItem) => { 
        videoBoxData.forEach((inIntem) => {
            if (outItem.itemid === inIntem.id) {
                rankVote.push({
                    id: inIntem.id,
                    videoTitle: inIntem.title,
                    num: outItem.num,
                    nump: outItem.nump,
                    voteTitle: outItem.title,
                });
            }
        });
    });
    rankVote.sort((a, b) => b.num - a.num);

    return (
        <div className={styles.vote}>
            <Chip id="260870" title="票数排行榜标题图" groupName="中国力量" type="struct">
                <div className={styles.voteTitle}>
                    <img src={voteTitleImage} />
                </div>
            </Chip>
            <div className={styles.voteBox}>
                <div className={styles.voteBorder}>
                    <div className={styles.voteBorderTitle}>
                        当前票数排行榜<span className={styles.voteBorderTime}>(每日12:00更新)</span>
                    </div>
                    <div className={styles.voteBorderBox}>
                        {rankVote.length > 0 && (
                            <table className={styles.voteBorderTable}>
                                <thead>
                                    <tr>
                                        <th className={styles.voteTh1}>排行</th>
                                        <th className={styles.voteTh2}>名称</th>
                                        <th className={styles.voteTh3}>当前票数</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rankVote.slice(0, 6).map((item, index) => {
                                        return (
                                            <tr key={item.id}>
                                                <td className={styles.voteTd1}>{index <= 2 ? <img src={rankNumList[index]} /> : index + 1}</td>
                                                <td className={styles.voteTd2}>
                                                    <div className={styles.voteTdText}>{item.videoTitle}</div>
                                                </td>
                                                <td className={styles.voteTd3}>{item.num}票</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        )}
                        {rankVote.length >= 6 && (
                            <>
                                <div className={styles.voteBorderLine} />
                                <table className={styles.voteBorderTable}>
                                    <thead>
                                        <tr>
                                            <th className={styles.voteTh1}>排行</th>
                                            <th className={styles.voteTh2}>名称</th>
                                            <th className={styles.voteTh3}>当前票数</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rankVote.slice(6, 12).map((item, index) => {
                                            return (
                                                <tr key={item.id}>
                                                    <td className={styles.voteTd1}>{index + 7}</td>
                                                    <td className={styles.voteTd2}>
                                                        <div className={styles.voteTdText}>{item.videoTitle}</div>
                                                    </td>
                                                    <td className={styles.voteTd3}>{item.num}票</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <a href="https://news.ifeng.com/loc/chinapower/survey" target="_blank" rel="noreferrer" className={styles.voteBorderButton}>
                投票赢抽奖机会
            </a>
        </div>
    );
};

Vote.propTypes = {
    surveyData: PropTypes.object,
    videoBoxData: PropTypes.array,
    voteTitleImage: PropTypes.string,
};

export default errorBoundary(Vote);
